import PropTypes from 'prop-types';
import React, { useState } from 'react';

import { clientApi } from 'helpers/api/client';

import { Portal } from 'components/Portal';
import { Header } from 'components/Header';
import { ButtonIcon } from 'components/Button';

import { TableLabel, TableProp, TableValueDynamic } from './TableItems';
import { ModalCreateContact } from './ModalCreateContact';

import '../style.scss';

const ModalCreateLegal = ({ onSubmit, onClose, pending, defaultValues }) => {
  const [values, setValues] = useState({
    EDRPOU: '',
    FIO: '',
    PhMain: '',
    PhAdd: '',
    INN: '',
    document: '',
    AddrOfficial: '',
    AddrFact: '',
    AddrPost: '',
    Email: '',
    ...defaultValues,
  });
  const [errors, setErrors] = useState({});
  const [createContactModal, setCreateContactModal] = useState(false);
  const [pendingInternal, setPendingInternal] = useState(false);

  const handleCopy = () => {
    handleValue('AddrFact', values.AddrOfficial);
  };

  const handleNext = () => {
    const errs = {};

    if (!values.EDRPOU) {
      errs.EDRPOU = true;
    }

    if (!values.FIO) {
      errs.FIO = true;
    }

    if (!values.PhMain) {
      errs.PhMain = true;
    }

    if (!values.AddrOfficial) {
      errs.AddrOfficial = true;
    }

    if (!values.AddrFact) {
      errs.AddrFact = true;
    }

    if (!values.Email) {
      errs.Email = true;
    }

    if (Object.keys(errs).length > 0) {
      setErrors(errs);
      return;
    }

    setCreateContactModal(true);
  };

  const handleSave = async (contactData) => {
    setCreateContactModal(false);

    const client = await onSubmit(values);

    setPendingInternal(true);
    await clientApi.createContactPerson({ ...contactData, clientID: client.id });
    onClose();
  };

  const handleValue = (key, value) => {
    if (errors[key]) {
      setErrors({ ...errors, [key]: false });
    }
    setValues({ ...values, [key]: value });
  };

  if (createContactModal) {
    return <ModalCreateContact onSubmit={handleSave} onClose={() => setCreateContactModal(false)} />;
  }

  return (
    <Portal id="modal-create-client" className="modal-create-client legal" onClose={onClose}>
      <Header title="Новый контрагент" onClose={onClose}></Header>

      <div className="client-create-grid legal">
        <TableProp title="ЕДРПОУ" icon="hashtag" />
        <div className="edrpou-wrapper">
          <TableValueDynamic
            err={errors.EDRPOU}
            value={values.EDRPOU}
            onChange={(value) => handleValue('EDRPOU', value)}
            mask="99999999"
            placeholder="XXXXXXXX"
          />
          <ButtonIcon className="btn-main btn-open-data-bot" icon="opendatabot" text="OpenDataBot" />
        </div>

        <TableProp title="Наименование" icon="userverify" />
        <TableValueDynamic
          err={errors.FIO}
          value={values.FIO}
          onChange={(value) => handleValue('FIO', value)}
          placeholder="Наименование"
        />

        <TableProp title="Телефон осн." icon="phone" />
        <TableValueDynamic
          err={errors.PhMain}
          value={values.PhMain}
          onChange={(value) => handleValue('PhMain', value)}
          mask="+380 99 999 99 99"
          placeholder="+380 XX XXX XX XX"
        />

        <TableProp title="Телефон доп." icon="phone" />
        <TableValueDynamic
          err={errors.PhAdd}
          value={values.PhAdd}
          onChange={(value) => handleValue('PhAdd', value)}
          mask="+380 99 999 99 99"
          placeholder="+380 XX XXX XX XX"
        />

        <TableProp title="ИНН" icon="hashtag" />
        <TableValueDynamic
          error={errors.INN}
          value={values.INN}
          onChange={(value) => handleValue('INN', value)}
          mask="9999999999"
          placeholder="XXXXXXXXXX"
        />

        <TableProp title="Юридический адрес" icon="location" />
        <TableValueDynamic
          err={errors.AddrOfficial}
          value={values.AddrOfficial}
          onChange={(value) => handleValue('AddrOfficial', value)}
          placeholder="Юридический адрес"
        />

        <TableLabel onClick={handleCopy} text="Юридический адрес соответствует фактическому" icon="copy" />

        <TableProp title="Фактический адрес" icon="location" />
        <TableValueDynamic
          err={errors.AddrFact}
          value={values.AddrFact}
          onChange={(value) => handleValue('AddrFact', value)}
          placeholder="Фактический адрес"
        />

        <TableProp title="Почтовый адрес" icon="location" />
        <TableValueDynamic
          err={errors.AddrPost}
          value={values.AddrPost}
          onChange={(value) => handleValue('AddrPost', value)}
          placeholder="Почтовый адрес"
        />

        <TableProp title="Эл. почта" icon="email" />
        <TableValueDynamic
          err={errors.Email}
          value={values.Email}
          onChange={(value) => handleValue('Email', value)}
          placeholder="example@gmail.com"
        />
      </div>

      <div className="buttons-block" style={{ margin: 0, marginBottom: 15 }}>
        <ButtonIcon
          className="btn-main btn-save"
          icon="save"
          pending={pending || pendingInternal}
          onClick={handleNext}
          text="Продолжить"
        />
      </div>
    </Portal>
  );
};

ModalCreateLegal.propTypes = {
  onSubmit: PropTypes.func.isRequired,
  onClose: PropTypes.func.isRequired,
  pending: PropTypes.bool,
  defaultValues: PropTypes.object,
};

ModalCreateLegal.defaultProps = {
  pending: false,
  defaultValues: {},
};

export { ModalCreateLegal };
